export function getAlignmentGuides(selNode,allChildren,scW,scH,threshold=8){
  if(!selNode)return{vLines:[],hLines:[]};
  const guides={vLines:[],hLines:[]};
  const sel={x:selNode.styles.x,y:selNode.styles.y,w:selNode.styles.width,h:selNode.styles.height};
  const others=allChildren.filter(n=>n.id!==selNode.id).map(n=>({id:n.id,x:n.styles.x,y:n.styles.y,w:n.styles.width,h:n.styles.height}));
  
  // Static screen alignments
  const screenCenterX = scW / 2;
  const screenCenterY = scH / 2;
  
  // Vertical guides: screen center, and element alignments
  if(Math.abs(sel.x - screenCenterX) <= threshold) guides.vLines.push(screenCenterX);
  if(Math.abs((sel.x + sel.w) - screenCenterX) <= threshold) guides.vLines.push(screenCenterX - sel.w);
  if(Math.abs((sel.x + sel.w/2) - screenCenterX) <= threshold) guides.vLines.push(screenCenterX - sel.w/2);
  
  // Horizontal guides: screen center, and element alignments
  if(Math.abs(sel.y - screenCenterY) <= threshold) guides.hLines.push(screenCenterY);
  if(Math.abs((sel.y + sel.h) - screenCenterY) <= threshold) guides.hLines.push(screenCenterY - sel.h);
  if(Math.abs((sel.y + sel.h/2) - screenCenterY) <= threshold) guides.hLines.push(screenCenterY - sel.h/2);
  
  others.forEach(o=>{
    // Vertical alignments
    if(Math.abs(sel.x-(o.x))<=threshold)guides.vLines.push(o.x);
    if(Math.abs((sel.x+sel.w)-(o.x+o.w))<=threshold)guides.vLines.push(o.x+o.w-sel.w);
    if(Math.abs((sel.x+sel.w/2)-(o.x+o.w/2))<=threshold)guides.vLines.push(o.x+o.w/2-sel.w/2);
    
    // Horizontal alignments
    if(Math.abs(sel.y-(o.y))<=threshold)guides.hLines.push(o.y);
    if(Math.abs((sel.y+sel.h)-(o.y+o.h))<=threshold)guides.hLines.push(o.y+o.h-sel.h);
    if(Math.abs((sel.y+sel.h/2)-(o.y+o.h/2))<=threshold)guides.hLines.push(o.y+o.h/2-sel.h/2);
  });
  
  return{vLines:[...new Set(guides.vLines)],hLines:[...new Set(guides.hLines)]};
}
